import './MGModalitySubscription.css'
import list_item from '../../images/list_item.svg'
import { getLOGOUT } from "../../env";

export default function MGModalityCardSubscription({ title, imgUrl, bullets, onClick, publicURL }) {

    const url = publicURL + imgUrl
    console.log(url);

    return (
        <div className='MGModalityCardSubscription-container' >
            <img className='MGModalityCardSubscription-img' src={url} />
            <div className='MGModalityCardSubscription-text'>
                <h3>{title}</h3>
                {bullets.map((bullet) => (
                    <li >
                        <img src={list_item} />
                        <p>{bullet.text}</p>
                    </li>
                ))}
            </div>
            <div className='MGModalityCardSubscription-button'>
                <button
                    className="MGModalityCardSubscription-button"
                    onClick={onClick}>
                    {'Subscrever'}
                </button>
            </div>
        </div>
    );
}


